import { connect } from 'react-redux';

import { withPresence } from 'hocs';

import { presenceActions } from '../../presence/actions/presenceActions';
import { teamActions } from '../actions/teamPage';
import {
  TeamPageDispatchPropsT,
  TeamPage as TeamPageImpl,
  TeamPageStatePropsT,
} from '../components';

const { selectTeamMembersFilter, setPresenceFilters } = teamActions;

const mapStateToProps = (state): TeamPageStatePropsT => {
  return {
    favourites: state.settings.personal.favouriteTeamMemberIds,
    presenceFilters: state.team.presenceFilters,
  };
};

const mapDispatchToProps = (dispatch): TeamPageDispatchPropsT => {
  return {
    selectTeamMembersFilter: (filter: string) =>
      dispatch(selectTeamMembersFilter({ filter })),
    setPresenceFilters: (params) => dispatch(setPresenceFilters(params)),
    presenceGetAll: (userId: string) =>
      dispatch(presenceActions.presenceGetAll(userId)),
  };
};

const TeamPageWithPresence = withPresence(TeamPageImpl, { pageSize: 50 });

const TeamPageConnected = connect<TeamPageStatePropsT, TeamPageDispatchPropsT>(
  mapStateToProps,
  mapDispatchToProps,
)(TeamPageWithPresence);

export { TeamPageConnected as TeamPage };
